import { flare } from "@flareapp/js";
import { flareVue } from "@flareapp/vue";
import { redactFlareReport } from "~/lib/telemetry/flare";

export default defineNuxtPlugin({
    name: "flare",
    setup(nuxtApp) {
        if (nuxtApp.$config.public.appEnv === "local") {
            return;
        }

        const { data: user } = storeToRefs(useUserStore());

        watchEffect(() => {
            flare.addContextGroup(
                "Master",
                user.value
                    ? {
                          name: user.value?.master.name,
                      }
                    : {
                          name: "No Appname found",
                      },
            );

            // ids only: no e-mail, no name
            flare.addContextGroup(
                "User",
                user.value
                    ? {
                          id: user.value.id,
                      }
                    : {
                          name: "Not logged in",
                      },
            );
        });

        flare.light(nuxtApp.$config.public.flareAppKey);

        flare.beforeSubmit = redactFlareReport;

        nuxtApp.vueApp.use(flareVue);

        nuxtApp.hook("vue:error", async (error, instance, info) => {
            const flareReportError = error as Error;

            flare.addContextGroup("Info", {
                additional_Info: info,
                title: flareReportError.message,
            });
            await flare.report(flareReportError);
        });
    },
});
